import { gql } from 'graphql.macro';

export const addPdfTemplate = gql`
    mutation addPdfTemplate($templateName: String!, $htmlContent: String!, $enabled: Boolean!, $lab: MongoDbObjectId!) {
        addPdfTemplate(templateName: $templateName, htmlContent: $htmlContent, enabled: $enabled, lab: $lab) {
            _id
            templateName
            htmlContent
            enabled
            lab
        }
    }
`;
